import { log } from '../lib/logger';
import { isHoliday } from './calculate-holiday';
import { format, parse } from 'date-fns';

const EN_GB_DATE_TIME_FORMAT = 'dd/MM/yyyy, HH:mm:ss';

export const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'holiday'] as const;

export type Weekday = typeof weekdays[number];

export function isWeekday(day: string): day is Weekday {
    return weekdays.findIndex((d) => d === day) > -1;
}

// Accepts mock timestamps for demoing/testing/developing
export const getTimestamps = (date: Date) => {
    const localDayName = isHoliday(date) ? weekdays[7] : getDayName(date);
    const localCurTime = Number(format(date, 'Hmm'));

    // convert dateTime of current time zone to the equivalent dateTime in Denmark
    const danishDateTime = parse(
        date.toLocaleString('en-GB', { timeZone: 'Europe/Copenhagen' }),
        EN_GB_DATE_TIME_FORMAT,
        new Date()
    );

    const danishEquivDayName = isHoliday(danishDateTime) ? weekdays[7] : getDayName(danishDateTime);
    const danishEquivCurTime = Number(format(danishDateTime, 'Hmm'));

    log('Using local day: ' + localDayName);
    log('Using local time: ' + localCurTime);
    log('Using danish equivalent time: ' + danishEquivCurTime);
    log('Using danish equivalent day: ' + danishEquivDayName);

    return {
        dayName: danishEquivDayName,
        curTime: danishEquivCurTime,
        date: danishDateTime,
        localDayName,
        localCurTime,
    };
};

const getDayName = (date: Date) => {
    const dayNum = date.getDay();
    return weekdays[dayNum];
};
